export default "__VITE_ASSET__BkstlrNZ__"